import type { Lead } from '@/mocks/admin';

interface ConfirmDeleteModalProps {
  lead: Lead;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ConfirmDeleteModal({ lead, onClose, onConfirm }: ConfirmDeleteModalProps) {
  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl overflow-hidden">
        {/* Header */}
        <div className="px-6 pt-6 pb-5 border-b border-gray-100">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-red-50 border border-red-100">
                <i className="ri-delete-bin-line text-red-500 text-lg" />
              </div>
              <div>
                <h2 className="text-gray-900 font-black text-lg leading-tight">Excluir Lead</h2>
                <p className="text-gray-400 text-sm">Esta ação não pode ser desfeita</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer flex-shrink-0"
            >
              <i className="ri-close-line text-gray-400 text-lg" />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="p-6">
          <p className="text-gray-600 text-sm mb-4">
            Tem certeza que deseja excluir o lead abaixo? Todos os seus dados serão removidos permanentemente.
          </p>

          <div className="bg-gray-50 rounded-xl p-4 border border-gray-100">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-200 flex-shrink-0">
                <span className="text-gray-600 text-sm font-black">{lead.nome.charAt(0)}</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-gray-900 text-sm font-bold truncate">{lead.nome}</p>
                <p className="text-gray-400 text-xs truncate">{lead.email}</p>
              </div>
            </div>
            {lead.diagnostico && (
              <div className="mt-3 pt-3 border-t border-gray-200 flex items-center gap-2">
                <i className="ri-bar-chart-2-line text-gray-400 text-xs" />
                <span className="text-gray-500 text-xs">
                  Diagnóstico Nível {lead.diagnostico.nivelNumero} — {lead.diagnostico.percentualGeral}%
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="flex-shrink-0 px-6 py-4 border-t border-gray-100 bg-gray-50 flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 flex items-center justify-center gap-2 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 font-bold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-close-line text-sm" />
            Cancelar
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 flex items-center justify-center gap-2 bg-red-600 hover:bg-red-500 text-white font-bold text-sm py-3 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-delete-bin-line text-sm" />
            Excluir
          </button>
        </div>
      </div>
    </div>
  );
}
